import React from "react";
import { Box, Checkbox, Col, Dialog, Divider, FabButton, Flex, Gap, InputField, Row, SelectField, Typography } from "../../ppui";
import { TbPencil, } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../style";
import { VscPercentage } from "react-icons/vsc";

const StatutoryEsiDetails = () => {
   // Modal
   const [openStatutoryEPFModal, setOpenStatutoryEPFModal] =
   React.useState(false);
   const [openEPFAddressModal, setOpenEPFAddressModal] = React.useState(false);


   const handleOpenStatutoryEPFModal = () => setOpenStatutoryEPFModal(true);
   const handleCloseStatutoryEPFModal = () => setOpenStatutoryEPFModal(false);

   const handleOpenEPFAddressModal = () => setOpenEPFAddressModal(true);
   const handleCloseEPFAddressModal = () => setOpenEPFAddressModal(false);
   // Modal
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
       {`Employee's`}  State insurance Details
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryEPFModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

    <OrganizationEmDetails>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            ESI Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
          45764674354354354
          </Typography>



        </OrganizationBx>

      
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Circle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Monthly
          </Typography>
        </OrganizationBx>
        
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Employee Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
           0.75
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
          Employer Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            3.25
          </Typography>
          </OrganizationBx>

          <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
           Coverage Date
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
          04-11-2024
          </Typography>
        </OrganizationBx>

        
    


        <Divider gap={20} />
      </OrganizationEmDetails>

      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
        ESI Address Details
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenEPFAddressModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            ESI Office
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Garia station road
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Address
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Saltlake Sector -V
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            City
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Kolkata
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            State
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Westbengal
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Country
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            India
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            PIN Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            236765
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Location
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Kolkata
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>


      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Employee's State insurance Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openStatutoryEPFModal}
        onClose={handleCloseStatutoryEPFModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="ESI Code"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>
        
          <Col sm={6}>
            <InputField
              fullWidth
              label="Coverage Date"
              placeholder="Select Here..."
              type="date"
              valueSinc={true}
              required
            />
          </Col>
         
          <Col sm={6}>
            <InputField
              fullWidth
              disabled
              label="Employee Contribution"
              placeholder="Type Here..."
              type="number"
              prefix={<VscPercentage />}
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              disabled
              label="Employer Contribution"
              placeholder="Type Here..."
              type="number"
              prefix={<VscPercentage />}
              required
            />
          </Col>
         
        </Row>
      </Dialog>
      {/* Statutory-EPF-Modal */}


      {/* Statutory-EPF-Address */}
      <Dialog
        title="ESI Address Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openEPFAddressModal}
        onClose={handleCloseEPFAddressModal}
        onSubmit={() => alert("Submitted")}
        separator
        footer={
          <Box mr={"auto"}>
            <Checkbox
              size="sm"
              color="primary"
              label={"Including employer's contribution in the CTC"}
            
            />
          </Box>
      }
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="ESI Office"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Address"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="City"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="State"
              name="industry_type"
              options={[
                { id: "option1", name: "West Bengal" },
                { id: "option2", name: "Bihar" },
              ]}
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="City"
              name="industry_type"
              options={[
                { id: "option1", name: "India" },
                { id: "option2", name: "China" },
              ]}
              disabled
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Pin Code"
              placeholder="Select Here..."
              type="number"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Location"
              placeholder="Select Here..."
              type="number"
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Address */}

    </>
  );
};

export default StatutoryEsiDetails;
